import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {
  type RepoIssuesDashboardContentResponse,
  RepoIssuesDashboardContentResponseSchema,
} from '@github-ui/dotcom-schema/types/issues/v1/repo_issues_dashboard'

import {issuesAppBuilder} from '../config/app-builder'
import {issuesIndexQueryResolver} from '../helpers/issues-index-query-resolver'

/**
 * Repo Issues#index content route. The main query hits the repo content endpoint
 * (`/:owner/:repo/issues?q=&page=`) and reuses the mixed issue + PR payload shape.
 */
export function buildIssuesIndexContentRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('issuesIndexContentRoute', {
    path: '/:owner/:repo/issues',
    queries: [
      mainQuery<RepoIssuesDashboardContentResponse>({
        schema: RepoIssuesDashboardContentResponseSchema,
        queryDeps: ({pathname, searchParams}) => {
          const q = issuesIndexQueryResolver({searchParams})
          return {
            pathname,
            searchParams: {q, page: searchParams.get('page') || '1'},
          }
        },
      }),
    ],
  })
}

export const issuesIndexContentRoute = buildIssuesIndexContentRoute(issuesAppBuilder)
